import { CreditCardIcon, UserIcon, ViewColumnsIcon } from "@heroicons/react/20/solid";
import { BuildingOffice2Icon } from "@/icons/solid";
import React, { useState } from "react";
import { connect } from "react-redux";

const AdvisorCreateCompany = ({ nextPage, updateCompanyDetails, existingCompanyDetails, profile, advisorName, newOrg, loadedCompanySettings }) => {
	const [advisor, setAdvisor] = useState(existingCompanyDetails?.advisor || null);
	const [paidByAdvisor, setPaidByAdvisor] = useState(existingCompanyDetails?.paidByAdvisor || null);

	const onSubmit = () => {
		if (newOrg) {
			updateCompanyDetails({ advisor, paidByAdvisor });
		} else {
			loadedCompanySettings({advisor, paidByAdvisor });
			nextPage();
		}
	};

	return (
		<div
			className="tab-pane fade in p-0 active content"
			id="btabs-alt-static-justified-general"
		>
			<div className="col-xs-12">
				<div style={{ display: "grid", gridTemplateColumns: "2fr 1fr" }}>
					<h4 style={{ textAlign: "center", padding: "1.5rem" }}>{advisorName}</h4>
					<h4 style={{ textAlign: "center", padding: "1.5rem" }}>In-House</h4>
				</div>
				<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-evenly",
							textAlign: "center",
							paddingLeft: "1rem",
							paddingRight: "1rem",
						}}
					>
						<div
							className="item item-circle bg-primary"
							style={{ position: "relative", height: "9rem", width: "9rem", margin: "auto" }}
						>
							<ViewColumnsIcon
								style={{
									position: "absolute",
									height: "7.5rem",
									color: "white",
									right: "0.75rem",
									top: "0.75rem",
								}}
							/>
							<UserIcon
								style={{
									position: "absolute",
									height: "4rem",
									color: "white",
									right: "0.5rem",
									top: "4rem",
									background: "#ea611c",
									borderRadius: "5rem",
								}}
							/>
						</div>
						<h4>Managed by Advisor</h4>
						<span className="text-muted">
							This company will be <u>managed by {advisorName}</u> and the <u>company will pay</u> for
							their usage
						</span>
						<SelectButton
							selected={advisor && !paidByAdvisor}
							onSelect={() => {
								setAdvisor(profile.advisorId);
								setPaidByAdvisor(false);
							}}
						/>
					</div>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							textAlign: "center",
							borderLeft: "1px solid #ea611c",
							borderRight: "1px solid #ea611c",
							paddingLeft: "1rem",
							paddingRight: "1rem",
						}}
					>
						<div
							className="item item-circle bg-primary"
							style={{
								position: "relative",
								height: "9rem",
								width: "9rem",
								margin: "auto",
							}}
						>
							<ViewColumnsIcon
								style={{
									position: "absolute",
									height: "7.5rem",
									color: "white",
									right: "0.75rem",
									top: "0.75rem",
								}}
							/>
							<CreditCardIcon
								style={{
									position: "absolute",
									height: "4rem",
									color: "white",
									right: "0.5rem",
									top: "4rem",
									padding: "0.5rem",
									background: "#ea611c",
									borderRadius: "5rem",
								}}
							/>
						</div>
						<h4>Managed & Paid for by Advisor</h4>
						<span className="text-muted">
							This company will be <u>managed by {advisorName}</u> and <u>advisor will pay</u> for the
							company's usage
						</span>
						<SelectButton
							selected={advisor && paidByAdvisor}
							onSelect={() => {
								setAdvisor(profile.advisorId);
								setPaidByAdvisor(true);
							}}
						/>
					</div>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							textAlign: "center",
							paddingLeft: "1rem",
							paddingRight: "1rem",
						}}
					>
						<div
							className="item item-circle bg-primary"
							style={{ position: "relative", height: "9rem", width: "9rem", margin: "auto" }}
						>
							<BuildingOffice2Icon
								style={{
									position: "absolute",
									height: "7.5rem",
									color: "white",
									right: "0.5rem",
									top: "0.5rem",
								}}
							/>
							<UserIcon
								style={{
									position: "absolute",
									height: "4rem",
									color: "white",
									right: "0.5rem",
									top: "4rem",
									background: "#ea611c",
									borderRadius: "5rem",
								}}
							/>
						</div>
						<h4>Independent</h4>
						<span className="text-muted">
							This company will be <u>managed by itself and will pay</u> for its own usage
						</span>
						<SelectButton
							selected={!advisor && !paidByAdvisor}
							onSelect={() => {
								setAdvisor(null);
								setPaidByAdvisor(null);
							}}
						/>
					</div>
				</div>
			</div>
			<button
				className="btn btn-success right"
				type="submit"
				onClick={() => onSubmit()}
			>
				Next Page
			</button>
			<div className="clearfix" />
		</div>
	);
};

const SelectButton = ({ selected, onSelect }) => {
	return (
		<button
			className={`btn btn-primary`}
			style={{ width: "min-content", margin: "auto", marginTop: "1rem" }}
			disabled={selected}
			type="button"
			onClick={onSelect}
		>
			{selected ? "Selected" : "Select"}
		</button>
	);
};

const mapStateToProps = (state) => {
	return {
		profile: state?.my?.profile,
		advisorName: state?.my?.profile?.advisorName,
		companyExists: !!state.company.newCompany.org,
		existingCompanyDetails: state.company.newCompany,
		newOrg: state?.company?.newCompany?.org,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorCreateCompany);
